export default __webpack_public_path__ + "static/media/Upload.svg.7689bda2.svg";